interface TextInputProps {
  id: string;
  type: string;
  label?: string;
  labelColour?: string;
  className: string;
  ariaLabel?: string;
  placeholder?: string;
  autoComplete?: string;
  required?: boolean;
  children?: React.ReactNode;
  showLabel?: boolean;
  state?: any;
  stateName?: any;
  onChange?: any;
  disabled?: boolean;
  small?: string | null;
}

export default function TextInput({
  id,
  type,
  label,
  labelColour,
  className,
  ariaLabel,
  placeholder,
  autoComplete,
  required,
  children,
  showLabel,
  state,
  stateName,
  onChange,
  disabled,
  small,
}: TextInputProps) {
  return (
    <div>
      {showLabel ? (
        <label
          htmlFor={id}
          className={`mb-3 block text-left text-sm font-medium ${labelColour}`}
        >
          {label}
        </label>
      ) : (
        <label
          htmlFor={id}
          className={`mb-3 block text-left text-sm font-medium ${labelColour}`}
        />
      )}
      {disabled ? (
        <input
          id={id}
          type={type}
          className={className}
          placeholder={placeholder}
          aria-label={ariaLabel}
          autoComplete={autoComplete}
          required={required}
          onChange={(e) => onChange({ ...state, [stateName]: e.target.value })}
          value={state[stateName]}
          disabled
        >
          {children}
        </input>
      ) : (
        <input
          id={id}
          type={type}
          className={className}
          placeholder={placeholder}
          aria-label={ariaLabel}
          autoComplete={autoComplete}
          value={state[stateName]}
          required={required}
          onChange={(e) => onChange({ ...state, [stateName]: e.target.value })}
        >
          {children}
        </input>
      )}
      {small !== null && (
        <p className="text-xs text-left text-secondary/70 mt-2">{small}</p>
      )}
    </div>
  );
}

TextInput.defaultProps = {
  ariaLabel: "",
  labelColour: "text-black",
  placeholder: "",
  autoComplete: "",
  required: true,
  showLabel: false,
  state: {},
  stateName: "",
  onChange: () => {},
  disabled: false,
  small: null,
};
